import React, { useLayoutEffect, useState, useContext } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { AuthContext } from "../Context/AppContext";

const NavBar = ({ children }) => {
  const { userInfo, setUserInfo, handleShowModalUserSettings } = useContext(AuthContext);
  const [moveSidebar, setMoveSidebar] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // Hook to get the current route

  const handlerLogOut = () => {
    localStorage.removeItem("token-api");
    setUserInfo({
      firstName: "",
      lastName: "",
    });
    navigate(`/`);
  };

  // Immediately apply sidebar class change
  useLayoutEffect(() => {
    const sidebar = document.getElementById("sidebar");
    if (sidebar) {
      sidebar.classList.toggle("collapsed", moveSidebar);
    }
  }, [moveSidebar]);




  return (
    <div className="wrapper">
      <nav id="sidebar" className={!moveSidebar ? "sidebar" : "sidebar collapsed"}>
        <div className="sidebar-content js-simplebar">
          <ul className="sidebar-nav">
            <li className="sidebar-header">{/* Nightspot */}</li>
            <li className="sidebar-item active">
              <ul id="dashboards" className="list-unstyled collapse show" data-bs-parent="#sidebar">
                <a href="/my/dashboard">
                  <img src="/img/logo/logo.svg" alt="Logo" className="sidebar-brand" />
                </a>
                <li className={`sidebar-item ${location.pathname === "/my/dashboard" ? "active" : ""}`}>
                  <Link className="sidebar-link" to="/my/dashboard">
                    <i className="fa-solid fa-home"></i> Página Inicial
                  </Link>
                </li>
                <li className={`sidebar-item ${location.pathname === "/my/nightspots" ? "active" : ""}`}>
                  <Link className="sidebar-link" to="/my/nightspots">
                    <i className="fa-solid fa-location-dot ms-1"></i> Nightspots
                  </Link>
                </li>
                <li className={`sidebar-item ${location.pathname === "/my/events" ? "active" : ""}`}>
                  <Link className="sidebar-link" to="/my/events">
                    <i className="fa-solid fa-calendar-days ms-1"></i> Eventos
                  </Link>
                </li>
                <li className={`sidebar-item ${location.pathname === "/my/promoters" ? "active" : ""}`}>
                  <Link className="sidebar-link" to="/my/promoters">
                    <i className="fa-solid fa-users me-2"></i> Promotores
                  </Link>
                </li>
                <li className="sidebar-item disabled">
                  <span className="sidebar-link">
                    <i className="fa-solid fa-bolt"></i> Campanhas <span className="badge bg-warning">Soon</span>
                  </span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
      <div className="main">
        <nav className="navbar navbar-expand navbar-bg">
          <a className="sidebar-toggle" onClick={() => setMoveSidebar(!moveSidebar)}>
            <i className="hamburger align-self-center"></i>
          </a>
          {/* <ul class="navbar-nav ">
            <li class="nav-item px-2 dropdown d-sm-inline-block">
              <a class="nav-link dropdown-toggle" href="#" id="servicesDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Mega menu
              </a>
              <div class="dropdown-menu dropdown-menu-start dropdown-mega" aria-labelledby="servicesDropdown" style={{ overflow: 'hidden' }}>
                <div class="d-md-flex align-items-start justify-content-start">
                  <div class="dropdown-mega-list">
                    <div class="dropdown-header">UI Elements</div>
                    <a class="dropdown-item" href="#">Alerts</a>
                    <a class="dropdown-item" href="#">Buttons</a>
                    <a class="dropdown-item" href="#">Cards</a>
                    <a class="dropdown-item" href="#">Carousel</a>
                    <a class="dropdown-item" href="#">General</a>
                    <a class="dropdown-item" href="#">Grid</a>
                    <a class="dropdown-item" href="#">Modals</a>
                    <a class="dropdown-item" href="#">Tabs</a>
                    <a class="dropdown-item" href="#">Typography</a>
                  </div>
                </div>
              </div>
            </li>
          </ul> */}
          <div className="navbar-collapse collapse">
            <ul className="navbar-nav navbar-align">
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle d-none d-sm-inline-block" href="#" data-bs-toggle="dropdown">
                  <span>{userInfo.firstName} {userInfo.lastName}</span>
                </a>
                <div className="dropdown-menu dropdown-menu-end">
                  <a className="dropdown-item" onClick={handleShowModalUserSettings}>
                    <i className="align-middle me-1" data-lucide="user"></i> Perfil
                  </a>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item" onClick={handlerLogOut}>Sair</a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <main className="content">{children}</main>
      </div>
    </div>
  );
};

export default NavBar;
